import ContentWrapper from "@/components/wrappers/ContentWrapper";
import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { useParams } from "react-router";
import { useGetCommissionsSettingsLevel } from "../../../../common/api/queries";
import { EntityIdObject } from "../../../../common/types";
import { CommissionsLevelDetailView } from "../components/views/detail/CommissionsLevelDetailView";

export const CommissionsLevelDetailContainer = () => {
  const { id } = useParams<EntityIdObject>() as { id: string };

  const { data: level, isError } = useGetCommissionsSettingsLevel(id);

  return (
    <DisplayWrapper itemLoaded={!!level} isError={isError}>
      <ContentWrapper>{level ? <CommissionsLevelDetailView level={level} /> : undefined}</ContentWrapper>
    </DisplayWrapper>
  );
};
